import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import './App.css';

function App() {
  const [user, setUser]               = useState(null);
  const [token, setToken]             = useState(null);
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [resetToken, setResetToken]   = useState(null); // Supabase recovery token from email link

  // Restore session from localStorage
  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUser  = localStorage.getItem('user');
    if (savedToken && savedUser) {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
    }
  }, []);

  // Detect Supabase password-recovery token in URL hash
  // Supabase puts #access_token=...&type=recovery in the URL when a user
  // clicks the reset-password link in the email.
  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes('type=recovery') && hash.includes('access_token')) {
      const params = new URLSearchParams(hash.replace('#', ''));
      const accessToken = params.get('access_token');
      if (accessToken) {
        setResetToken(accessToken);
        // Clear the hash so it doesn't persist on reload
        window.history.replaceState(null, '', window.location.pathname);
      }
    }
  }, []);

  const handleLogin = (newToken, member) => {
    setToken(newToken);
    setUser(member);
    setResetToken(null);
  };

  const handleLogout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setCurrentPage('dashboard');
  };

  // Show login/reset screen when not authenticated (or when a reset token is present)
  if (!user || !token || resetToken) {
    return (
      <Login
        onLogin={handleLogin}
        resetToken={resetToken}
        onResetDone={() => setResetToken(null)}
      />
    );
  }

  return (
    <div className="app-container">
      {/* Top navbar — matches Recipe Collection style */}
      <header className="app-topbar">
        <div className="topbar-left">
          <h1 className="topbar-title">⚓ <em>Mooring System</em></h1>
        </div>

        <div className="topbar-right">
          <span className="topbar-user">{user.name}</span>

          <button
            className={`topbar-nav-btn ${currentPage === 'dashboard' ? 'active' : ''}`}
            onClick={() => setCurrentPage('dashboard')}
          >
            🌊 Dashboard
          </button>

          <button
            className={`topbar-nav-btn ${currentPage === 'reports' ? 'active' : ''}`}
            onClick={() => setCurrentPage('reports')}
          >
            📊 Reports
          </button>

          <button className="topbar-signout" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      </header>

      {/* Main content */}
      <main className="app-main">
        {currentPage === 'dashboard' ? (
          <Dashboard user={user} token={token} />
        ) : currentPage === 'reports' ? (
          <Reports user={user} token={token} />
        ) : null}
      </main>
    </div>
  );
}

export default App;
